import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { isEmpty, first, includes } from 'lodash-es';

import listConfig, { KEYWORD_LIST_TYPE, MARKET_LIST_TYPE } from './listTypeConfig';
import Tooltip from '../Tooltip';

const renderElementWithReplace = (elementText, replaceText) => (
  <Fragment>
    <span className="mr-sm text-red text-truncate">{elementText}</span>
    <div>
      <span className="text-xxs text-blue">{replaceText}</span>
      <i className="hicon-usage ml-xs text-blue" />
    </div>
  </Fragment>
);

const renderElementWithWarning = (elementText, warningText) => (
  <Fragment>
    <span className="mr-sm text-truncate">{elementText}</span>
    <div>
      <span className="text-xxs">{warningText}</span>
      <i className="hicon-plus-thin ml-xs warning-icon" />
    </div>
  </Fragment>
);

class ListElement extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool.isRequired,
    added: PropTypes.bool.isRequired,
    onAddClick: PropTypes.func.isRequired,
    onRemoveClick: PropTypes.func.isRequired,
    onReplaceClick: PropTypes.func.isRequired,
    entitiesDifference: PropTypes.number.isRequired,
    entitiesSum: PropTypes.number.isRequired,
    conflicts: PropTypes.array,
    listType: PropTypes.oneOf([MARKET_LIST_TYPE, KEYWORD_LIST_TYPE]).isRequired,
    enterprise: PropTypes.bool,
    owner: PropTypes.bool,
  };
  static defaultProps = {
    enterprise: false,
    owner: false,
  };

  getConflictType() {
    const { conflicts } = this.props;
    return first(conflicts).conflict_type;
  }
  hasConflicts() {
    const { conflicts } = this.props;
    return !isEmpty(conflicts);
  }
  hasReplaceConflicts() {
    return (
      this.hasConflicts() &&
      includes(listConfig[this.props.listType].conflictsTypes, this.getConflictType())
    );
  }
  listDisabled() {
    const { disabled, enterprise, owner } = this.props;
    return disabled || enterprise ? !owner : !this.hasReplaceConflicts() && this.hasConflicts();
  }
  handleClick = () => {
    const { id, disabled, added, onAddClick, onRemoveClick, onReplaceClick } = this.props;

    if (disabled || this.listDisabled()) return;

    if (this.hasReplaceConflicts()) {
      onReplaceClick(id);
      return;
    }

    if (this.hasConflicts()) return;

    if (added) {
      onRemoveClick(id);
    } else {
      onAddClick(id);
    }
  };
  renderElement() {
    const { name, added, enterprise } = this.props;
    if (this.hasConflicts()) {
      return listConfig[this.props.listType].renderElement(
        name,
        this.getConflictType(),
        renderElementWithReplace,
        renderElementWithWarning
      );
    }
    return (
      <Fragment>
        <span>
          {enterprise && <i className="hicon-enterprise text-16" />}
          <span className="mr-sm text-truncate">{name}</span>
        </span>
        {added ? (
          <i className="hicon-check-bold-short" />
        ) : (
          <i className="hicon-plus-thin text-quiet" />
        )}
      </Fragment>
    );
  }
  render() {
    const { disabled, added, entitiesDifference, entitiesSum, listType, enterprise, owner } =
      this.props;
    const listDisabled = this.listDisabled();
    const tooltipContent =
      enterprise && !owner
        ? `Only the list owner(s) can add ${listConfig[listType].entityName}s to this list.`
        : listConfig[listType].disabledElementTooltip(
            disabled,
            entitiesSum,
            entitiesDifference,
            listConfig[listType].listName
          );

    return (
      <Tooltip content={tooltipContent}>
        <li
          className={cx('markets-list-item', {
            'market-disabled': listDisabled,
            'market-added': added,
          })}
          onClick={this.handleClick}
        >
          {this.renderElement()}
        </li>
      </Tooltip>
    );
  }
}

export default ListElement;
